import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './ContactForm.css';

const EMPTY = { name: '', email: '', subject: '', message: '' };

/**
 * The dark booking form from the contact block. Same EmailJS transport
 * everywhere; `showSubject` adds the "what do you need help with?" line for
 * the roomier standalone /contact page.
 */
const ContactForm = ({ showSubject = false }) => {
  const [formData, setFormData] = useState(EMPTY);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: showSubject ? formData.subject : 'Free AI assessment request',
          message: formData.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setStatus('success');
        setFormData(EMPTY);
      })
      .catch((err) => {
        console.error('Failed to send message:', err);
        setStatus('error');
      });
  };

  return (
    <form className="ak-form" onSubmit={handleSubmit}>
      <div className="ak-field">
        <label htmlFor="ak-name">name</label>
        <input
          id="ak-name"
          name="name"
          type="text"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your name"
          required
        />
      </div>

      <div className="ak-field">
        <label htmlFor="ak-email">email</label>
        <input
          id="ak-email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="you@company.com"
          required
        />
      </div>

      {showSubject && (
        <div className="ak-field">
          <label htmlFor="ak-subject">what do you need help with?</label>
          <input
            id="ak-subject"
            name="subject"
            type="text"
            value={formData.subject}
            onChange={handleChange}
            placeholder="e.g. quoting takes us all day"
            required
          />
        </div>
      )}

      <div className="ak-field">
        <label htmlFor="ak-message">what's slowing you down?</label>
        <textarea
          id="ak-message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="A sentence or two is plenty."
          required
        />
      </div>

      {status === 'success' && (
        <p className="ak-form-note ak-form-ok" role="status">
          Sent. We'll be in touch within one business day.
        </p>
      )}
      {status === 'error' && (
        <p className="ak-form-note ak-form-err" role="status">
          Something went wrong — email us directly at hello@akeyreu.com.
        </p>
      )}

      <button type="submit" className="ak-form-submit" disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending…' : 'Book the call'}
      </button>
    </form>
  );
};

export default ContactForm;
